import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { MarketingLayout } from "@/components/layout/MarketingLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceAreas from "@/pages/ServiceAreas";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import PestGuide from "@/pages/PestGuide";
import Blog from "@/pages/Blog";
import RequestInspection from "@/pages/RequestInspection";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Portal from "@/pages/Portal";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function ScrollTop() {
  const { pathname } = useLocation();
  if (typeof window !== "undefined") window.scrollTo(0, 0);
  return null;
}

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-brand-light"><div className="h-10 w-10 rounded-full border-4 border-brand-green border-t-transparent animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return children;
}

function RootRoutes() {
  const location = useLocation();
  // Detect Google OAuth callback synchronously (before ProtectedRoute runs)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/pest-guide" element={<PestGuide />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/request-inspection" element={<RequestInspection />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/portal" element={<Protected role="customer"><Portal /></Protected>} />
        </Route>
        <Route path="/admin/login" element={<Login admin />} />
        <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <RootRoutes />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
